<div class="bs-container-progress-bar bs-border-top-left-radius bs-border-top-right-radius th-bg-border-line-background">
    <div [style.width.%]="this.getProgressPercentage()"
         class="bs-progress th-bg-secondary bs-border-top-left-radius"
         [class.bs-border-top-right-radius]="this.getProgressPercentage() === this.getPorcentageLimit()">
    </div>
</div>